import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject, Subscription, interval, Observable } from "rxjs";
import { environment } from "../environments/environment";
import { WorkSpaceDto, NotebookDto, AssistantDto, ThreadDto, StudiaPlanDto, JobDto, Theme, AvatarImage, Me, LibraryCategory, Activity, Account, UserDto, WizardConfigDto, FolderDto, TabDto, ContentDto, ContentPositionDto, MessageDto, EvaluationDto, StudiaPlanTaskDto, CommunityGroupDto, LibraryBookDto, LibraryReviewDto, LibrarySubcategory, LibraryUserResumeDto, MemberGroupDto, MessageGroupDto, UserPaymentDto } from "../models/models";
import { AuthService } from "./auth.service";
import oboe from "oboe";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private _notificationWorkspace$ = new Subject<WorkSpaceDto>();
  workspaceSelected$ = this._notificationWorkspace$.asObservable();

  private _notificationNotebook$ = new Subject<NotebookDto>();
  bookSelected$ = this._notificationNotebook$.asObservable();

  private _notificationJobsQueue$ = new Subject<JobDto[]>();
  jobsQueue$ = this._notificationJobsQueue$.asObservable();

  private notifications: any[]=[];
  private workspaces: WorkSpaceDto[] = [];
  private subscribeBooks: NotebookDto[]=[];
  // private assistants: AssistantDto[] = [];
  // private threads: ThreadDto[] = [];
  private groups: CommunityGroupDto[]=[];
  private studiaPlans: StudiaPlanDto[]=[];
  private pendingJobs: JobDto[]=[];
  jobsSubscription!: Subscription;
  private pendingJobsFirstCheck:boolean = false;

  private notebooks: any[] = [];
  private tabs: any[] = [];

  colorsAvailable: Theme[] = [
    {id:"1", name:"tab-color-one", color:"One", hex:"#1563b0", hexlight:"#76b4f1", hexlight2:"#c9e4ff"},
    {id:"2", name:"tab-color-two", color:"Two", hex:"#aa9108", hexlight:"#e6cd42", hexlight2:"#fff5bb"},
    {id:"3", name:"tab-color-three", color:"Three", hex:"#d95d09", hexlight:"#f49555", hexlight2:"#ffe6d6"},
    {id:"4", name:"tab-color-four", color:"Four", hex:"#66095a", hexlight:"#A1118E", hexlight2:"#ffd4fa"},
    {id:"5", name:"tab-color-five", color:"Five", hex:"#00976a", hexlight:"#08C089", hexlight2:"#d3fff2"},
    {id:"6", name:"tab-color-six", color:"Six", hex:"#ca0d55", hexlight:"#EC1265", hexlight2:"#ffd7e6"}
  ];
  
  avatarsAvailable: AvatarImage[]=[
    {id:1, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar01.png"},
    {id:2, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar02.png"},
    {id:3, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar03.png"},
    {id:4,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar04.png"},
    {id:5,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar05.png"},
    {id:6,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar06.png"},
    {id:7,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar07.png"},
    {id:8,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar08.png"},
    {id:9,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar09.png"},
    {id:10,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar10.png"},
    {id:11,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar11.png"},
    {id:12,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar12.png"},
    {id:13,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar13.png"},
    {id:14,url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar14.png"}
  ];

  avatarsAssistantAvailable: AvatarImage[]=[
    {id:1, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar-bot01.png"},
    {id:2, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar-bot02.png"},
    {id:3, url:"https://scwcloud.blob.core.windows.net/public/studia_assets/avatar-bot03.png"}
  ];

  userInitialized: boolean = false;
  private menuExpanded: boolean = false;

  constructor(private http: HttpClient, private auth: AuthService) {       
  }

 

  public getMe(): Observable<any> {
    return this.http.get<any>(`${environment.nenomedCloudUrl}Kernel/GetMyCustomer`);    
  }
    public checkDevice(device): Observable<any> {
    return this.http.post<any>(`${environment.nenomedApiUrl}api/Account/ValidateDevice`, device);
  }

  Init() {

    this.tabs = [];
    return new Promise<void>((resolve, reject) => {
        console.log("AppInitService.init() called");
        ////do your initialisation stuff here  
        setTimeout(() => {
            console.log('AppInitService Finished');
            // this.currentWorkspace = this.workspaces[0];
            // this.currentNotebook = this.workspaces[0]?.books[0];
            // this.currentTab = this.currentNotebook?.tabs[0];
            this.userInitialized = true;
            resolve();
        }, 100);

    });
  }


}